//imports
import {
    BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL,
    BULK_ASSIGN_ALERT_TYPES_REQUEST,
    BULK_ASSIGN_ALERT_TYPES_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    devicesModels: [],
    result: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case BULK_ASSIGN_ALERT_TYPES_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, devicesModels: action.payload.data }

        case BULK_ASSIGN_ALERT_TYPES_REQUEST:
            return { ...state, loading: true }

        case BULK_ASSIGN_ALERT_TYPES_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "BULK_ASSIGN_ALERT_TYPES"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
